import Vuex from 'vuex'
import Vue from 'vue'
import qs from 'qs'
import { API_KEY, APLICATION_TYPE, AUTH_URL } from '../http/base-urls';

Vue.use(Vuex)

const axios = require("axios")

const estado = {
  token: null
}

const mutations = {
  AUTENTICADO(state, { token }) {
    state.token = token
  }
}
const actions = {
  autenticar({ commit }) {

    return new Promise((resolve, reject) => {
      var config = {
        method: 'get',
        url: `${AUTH_URL}?aplication_type=${APLICATION_TYPE}&api_key=${API_KEY}`,
        headers: {
          'Authorization': 'Basic c3lzLm9pYzpFJWVAJEp2ZDVxJGY='
        }
      };

      axios(config)
        .then(response => {
          let access_token = response.data.access_token
          localStorage.setItem("token", access_token)
          commit("AUTENTICADO", {
            token: access_token
          })
        })
        .catch(erro => console.log(erro))
    })
  }
}

export default new Vuex.Store({
  state: estado,
  mutations,
  actions
})